<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="故障类型"
      edit-title
      id-key="ClassId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="类型编号" prop="ClassNo">
          <span v-if="Mode == 0" class="detail-span">{{ data.ClassNo }}</span>
          <el-input v-else v-model="data.ClassNo" placeholder="请输入类型编号"></el-input>
        </el-form-item>
        <el-form-item label="类型名称" prop="ClassName">
          <el-input v-model="data.ClassName" placeholder="请输入类型名称"></el-input>
        </el-form-item>
        <el-form-item label="序号" prop="Sn">
          <el-input type="number" v-int v-model="data.Sn" style="width: 100px"></el-input>
          <!-- <el-input-number :min="0" v-model="data.Sn"></el-input-number> -->
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  data() {
    return {
      data: {
        ClassId: 0,
        ClassName: '',
        ClassNo: '',
        ClassType: 18, //0:物料/1:产品/2:客户/3:供应商/4:仓库/5:收入/6:费用/7:账号/8:颜色/9:设备/10:胶件/11:配件
        Pid: 0,
        Pname: '',
        Sn: 0,
        Status: 1
      },
      Mode: 1,
      api: require('@/api/ba/class').default,
      code_api: require('@/api/sy/serialCode').default,
      showList: [],
      rules: {
        EquipmentNo: [{ required: true, message: '请输入类型编码' }],
        EquipmentName: [{ required: true, message: '请输入类型名称' }]
      }
    }
  },
  methods: {
    // 打开时获取显示显示列表
    onCreateOpened(data) {
      console.log('onCreateOpened', data)
      if (data==null) {
        this.api.getMaxSn(this.data.ClassType, this.data.Pid).then(res => {
          this.data.Sn = res
        })
        this.code_api.previewNo('故障类型').then(res => {
          console.log('serialType', res)
          if (res.Code == 0) {
            this.Mode = res.Data.Mode
            this.data.ClassNo = res.Data.PreviewNo
          } else {
            this.$message.warning('获取故障类型编号失败')
          }
        })
      }
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true
      return this.showList.indexOf(data) !== -1 ? true : false
    },

    onEditOpened(data) {},

    onClosed() {
      this.showList = []
    }
  }
}
</script>